export enum ChatListPreviewKind {
  DEFAULT = 'default',
  FILES_ONLY = 'filesOnly',
  FILES_WITH_TEXT = 'filesWithText',
}

export enum ChatListPreviewActionCode {
  NONE = '',
  LAST_MESSAGE_IS_FILES = 'lastMessageIsFiles',
  VOICE_MESSAGE = 'voiceMessage',
}

export interface ChatListPreviewModel {
  raw: string;
  actionCode: string;
  kind: ChatListPreviewKind;
  isForwarded: boolean;
  filesText: string;
}

export interface ChatEventPreviewResult {
  preview: ChatListPreviewModel;
  isCallServiceMessage: boolean;
  isForwardedMessage: boolean;
}
